<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/stock/adjusts">{{ $t('stock_adjust_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link v-if="!header.IsApproved" :to="{ name: 'stock_adjust_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button v-if="!header.IsApproved" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="approveClick"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="printClick"><i class="fa fa-print"></i> {{ $t('print') }}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <h3 class="text-center font-m">{{$t('stock_adjust')}}</h3>
                    <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                    <div class="row">
                        <div class="col-sm-6">
                            <table style="width: 100%;">
                                <tbody>
                                    <tr>
                                        <td style="width: 100px;">{{ $t('branch') }}</td>
                                        <td style="width: 10px;">:</td>
                                        <td>{{header.BranchName}}</td>
                                    </tr>
                                    <tr>
                                        <td>សំគាល់</td>
                                        <td>:</td>
                                        <td>{{header.Remark}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table align="right">
                                <tbody>
                                <tr>
                                    <td>{{$t('barcode')}}</td>
                                    <td>:</td>
                                    <td>{{header.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(header.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th class="text-right">ចំនួនចាស់</th>
                                        <th class="text-right">{{$t('qty')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td class="text-right">{{ret.Quantity}}</td>
                                        <td class="text-right">{{ret.QuantityNew}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                header: {
                  IsApproved: true
                },
                lines: []
            }
        },
        mounted(){
            let id = this.$route.params.id;
            if(id != undefined && id != ''){
                this.findById(id);
            }
        },
        methods: {
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('stock/adjust/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.header = res.data.Json.AdjustHead;
                        this.lines = res.data.Json.AdjustLines;
                    }
                }).finally(function(){ loading.hide(); });
            },
            approveClick(){
                let loading = this.$loading.show();
                this.$api().post('stock/adjust/approve', { Id: this.$route.params.id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            },
            printClick(){
                window.open('/print/stockAdjust/' + this.$route.params.id, '_blank');
            }
        }
    }
</script>
